import axios from "axios";

export const FollowUser = async (userId: string, headers: any) => {
  const res = await axios.post(`/api/users/${userId}/follow`, {}, headers);
  return res.data;
};

export const UnfollowUser = async (userId: string, headers: any) => {
  const res = await axios.delete(`/api/users/${userId}/follow`, headers);
  return res.data;
};

export const GetFollowStatus = async (userId: string, headers?: any) => {
  const res = await axios.get(`/api/users/${userId}/follow-status`, headers);
  return res.data;
};

export const GetFollowers = async (userId: string, page = 1, headers?: any) => {
  const res = await axios.get(
    `/api/users/${userId}/followers?page=${page}`,
    headers,
  );
  return res.data;
};

export const GetFollowing = async (userId: string, page = 1, headers?: any) => {
  const res = await axios.get(
    `/api/users/${userId}/following?page=${page}`,
    headers,
  );
  return res.data;
};
